export function fetchService() {

  const refresh = async (): Promise<boolean> => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOST}oauth/refresh/`, {
        method: 'POST',
        credentials: 'include',
      });

      return response.status === 200;
    } catch (err) {
      return false;
    }
  }

  const fetchFile = async (url: string, params?: Record<string, string>, attempt = 0) => {
    try {
      const response = await fetch(url, {
        credentials: 'include',
        ...(params ? { params } : {}),
      });

      if (response.status === 401 || response.status === 410)
        !attempt && (await refresh()) && (await fetchFile(url, params, 1))
      else {
        const blob = await response.blob();
        const file = window.URL.createObjectURL(blob);
        window.location.assign(file);
      }
    } catch (err) {}
  }

  return {
    fetchFile,
  };
}